import { useMutation } from '@tanstack/react-query';
import { useApi } from 'app/shared/contexts/api';
import { apiRequest, HttpMethod } from '@hqo/shared-modules/dist/api-request';
import { useBuilding } from 'app/shared/contexts/building';

export enum UPDATE_OFFER_TYPE {
  CLAIM = 'claim',
  CANCEL = 'cancel',
}

interface UpdateOfferMutation {
  type: UPDATE_OFFER_TYPE;
  uuid: string | undefined;
}

export const useUpdateOfferMutation = () => {
  const { building } = useBuilding();
  const { apiUrl, getAuthHeaders } = useApi() as unknown as {
    apiUrl: string;
    getAuthHeaders: () => Promise<{ Authorization: string }>;
  };

  return useMutation({
    mutationFn: async ({ type, uuid }: UpdateOfferMutation) => {
      const headers = await getAuthHeaders();
      const apiPath = `${'/api/tenant/v1/buildings'}/${building?.uuid}${'/offers'}/${uuid}${
        type === UPDATE_OFFER_TYPE.CLAIM ? '/claim' : '/cancel'
      }`;

      const response = await apiRequest<unknown, void, void>({
        url: `${apiUrl}${apiPath}`,
        method: HttpMethod.PUT,
        headers,
      });

      return response.isEmpty() ? null : response.data;
    },
  });
};
